import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { Platform, Dimensions } from 'react-native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import Icon from '../icon';
const StyledRow = styled.View`
  flex-direction: row;
  height: 20px;
`;
const StyledImage = styled.Image`
  height: ${props => props.height}px;
  width: 100%;
  border-radius: 8px;
`;

const StyledInstruction = content => {
  const styles = {
    icon: {
      alignSelf: 'flex-end'
    },
    description: {
      alignSelf: 'center'
    }
  };
  return /*#__PURE__*/React.createElement(StyledRow, null, /*#__PURE__*/React.createElement(Icon.Feather, {
    name: content.icon,
    color: Colors.gray300,
    size: 20,
    style: styles.icon
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    weight: "regular",
    color: Colors.gray600,
    style: styles.description
  }, content.description));
};

export default function Capture(props) {
  const imageRef = useRef();
  const [height, setHeight] = useState();
  useEffect(() => {
    const imageWidth = Dimensions.get('screen').width;
    const imageHeight = imageWidth / 1.475;
    setHeight(imageHeight);
  }, [height]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "regular",
    color: Colors.gray600
  }, "Provide us with a good photo of your", ' ', props.documentName, '. ', "Make sure to capture all the important details on the document."), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), Platform.select({
    web: /*#__PURE__*/React.createElement(StyledImage, {
      ref: imageRef,
      source: {
        uri: props.image
      },
      height: height
    }),
    default: /*#__PURE__*/React.createElement(StyledImage, {
      ref: imageRef,
      source: props.image,
      height: height
    })
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(StyledInstruction, {
    icon: "sun",
    description: "Use a well lit room"
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(StyledInstruction, {
    icon: "slash",
    description: "No Flash"
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(StyledInstruction, {
    icon: "camera",
    description: "Hold the camera stable"
  }));
}
Capture.defaultProps = {
  image: '',
  documentName: ''
};
Capture.propTypes = {
  image: PropTypes.string,
  documentName: PropTypes.string
};
//# sourceMappingURL=capture.js.map